<div class="glass-modal">
    <h6 mat-dialog-title class="text-primary-color fw-bold">Terms & Conditions</h6>
    <mat-dialog-content>
        <app-privacy-and-terms [htmlFileName]="'termsandconditions.html'"></app-privacy-and-terms>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-flat-button (click)="closeDialog()" class="primary-btn ms-3 me-3 ps-4 pe-4">Close</button>
    </mat-dialog-actions>
</div>